export const isLogging = false;
export const isMapShown = true;
export const isDevChecker = { is: false, label: '' };
export const version = '0.2.10';

const getRuntimeEnv = (key, fallback = '') => {
  if (typeof window !== 'undefined' && window.__ENV__) {
    return window.__ENV__[key] || fallback;
  }
  return fallback;
};
export const REACT_APP_CUBA_URL = getRuntimeEnv(
  'REACT_APP_CUBA_URL',
  process.env.REACT_APP_CUBA_URL || '/ausweiss/rest/'
);

export const SERVER_HOST = REACT_APP_CUBA_URL;

if (isLogging) {
  // eslint-disable-next-line
  console.log(':: HOST NOW ::', SERVER_HOST, 'window.__ENV__', window.__ENV__);
}